import React from 'react';
import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const ColumnSearchHeader = React.memo(
  ({ column, isSearchable, value, onChange, enableColumnSearch }) => {
    const align = column?.headerAlign || 'left';
    return (
      <Box className={`column-search-header column-search-header--${align}`}>
        <Typography variant="caption" className="column-search-header__title">
          {column.headerName}
        </Typography>

        {enableColumnSearch ? (
          <Box className="column-search-header__field-wrapper">
            {isSearchable && (
              <TextField
                size="small"
                variant="outlined"
                value={value}
                onClick={(e) => e.stopPropagation()}
                onChange={onChange}
                placeholder=""
                className={`column-search-header__field ${
                  value ? 'column-search-header__field--has-value' : ''
                }`}
                InputProps={{
                  startAdornment: !value ? (
                    <InputAdornment position="start" className="column-search-header__search-icon">
                      <SearchIcon fontSize="inherit" />
                    </InputAdornment>
                  ) : null,
                }}
              />
            )}
          </Box>
        ) : null}
      </Box>
    );
  }
);

export default ColumnSearchHeader;
